// extracted by mini-css-extract-plugin
export default {"imagen":"Home_imagen__DXLfx","backGround":"Home_backGround__y9NuB","buttonChatBot":"Home_buttonChatBot__5g1bK","imagen2":"Home_imagen2__dfFFK","imagen1":"Home_imagen1__u2cGh"};